import React from "react";
import TabcordionContent from "components/page/campaign/tabcordion/TabcordionContent";
import DataContainer from "components/utility/data-container/DataContainer";

const TabcordionPage = () => {
	return (
		<div>
			<DataContainer data="tabcordionData">
				<TabcordionContent />
			</DataContainer>
		</div>
	);
};

export default TabcordionPage;
